import { useEffect, useCallback, useMemo } from "react";
import WebSocketManager from "../../../ws/client";

export function useOrderUpdates({ clientCode, setAllOrders }) {
    const topic = useMemo(() => {
        if (!clientCode) return null;
        return `/topic/clients/${clientCode}/orders`;
    }, [clientCode]);

    const handleMessage = useCallback((event) => {
        try {
            const { type, payload } = event;
            setAllOrders(prevOrders => {

                switch (type) {
                    case "CREATED":
                        if (prevOrders.some(o => o.order_id === payload.order_id)) {
                            return prevOrders;
                        }

                        return [payload, ...prevOrders];


                    case "UPDATED":
                    case "CANCELED":
                        return prevOrders.map(order =>
                            order.order_id === payload.order_id
                                ? payload
                                : order
                        );

                    default:
                        return prevOrders;

                }

            });

        } catch (error) {
            console.error("Erro processando WS de pedidos:", error);
        }

    }, [setAllOrders]);

    useEffect(() => {
        if (!topic) return;
        WebSocketManager.subscribe(topic, handleMessage);
        return () => {
            WebSocketManager.unsubscribe(topic);
        };
    }, [topic, handleMessage]);
}